<script>
  // The Quest Submissions review surface, opened over the command center on the
  // submission the moderator clicked. The server orders the queue
  // (`review_queue_ids`: the feed's pending submissions, oldest first). While the
  // surface is open, reviewed items stay where they are (←, U and the sibling
  // Example lookup depend on it) and new arrivals join the end, so this mount
  // keeps every id and item it has seen.
  import { untrack } from 'svelte'
  import ReviewSurface from '../../components/quest_submissions/review_surface.svelte'

  let { events, queueIds = [], startId, rejectionCategories = [], curationLevels = [], onExit, onDecision, onUndo } = $props()

  let order = $state.raw(untrack(() => [...queueIds]))
  const seen = {}

  $effect(() => {
    const arrivals = queueIds.filter((id) => !untrack(() => order).includes(id))
    if (arrivals.length > 0) order = [...untrack(() => order), ...arrivals]
  })

  const items = $derived.by(() => {
    // Events arrive newest first, so walk them oldest first and let the freshest copy win.
    ;[...events].reverse().forEach((event) => {
      if (event.quest_submission) seen[event.quest_submission.id] = event.quest_submission
    })
    return order.flatMap((id) => (seen[id] ? [seen[id]] : []))
  })
</script>

<ReviewSurface
  queue={{ items, totalCount: items.length, hasMore: false, loadMore: () => {} }}
  {startId}
  {rejectionCategories}
  {curationLevels}
  exitLabel="Back to feed"
  {onExit}
  {onDecision}
  {onUndo}
/>
